import { Link } from 'react-router-dom'
import { useShopsQuery } from '../../api/endpoints/trade'
import { useShellMode } from '../../shell/ShellContext'
import { Failure, Loading } from '../../ui/State'
import { LocationWindow } from '../LocationWindow'
import { VisitPlace } from '../mentors/MentorScreen'

export function TradersScreen() {
  useShellMode('window')
  const query = useShopsQuery()
  return <LocationWindow title="Продать торговцу" emblem="loc.shop" idBase="traders" bodyClassName="mentor-body">
    <p>Лишние вещи можно продать в любой лавке. Подойдите к торговцу и откройте вкладку «Продать»: там показаны цена и итоговая сумма.</p>
    {query.isLoading && <Loading />}
    {query.isError && <Failure error={query.error} retry={() => void query.refetch()} what="Торговцы" />}
    {query.data?.map(s => <section key={`${s.id}-${s.place_id}`} className="mentor-panel"><h3>{s.name}</h3>
      {s.here ? <Link to={`/play/shop/${s.id}?tab=sell`}>Открыть продажу — {s.place_name} →</Link> : <VisitPlace place={s.place_id} name={s.place_name} x={s.x} y={s.y} />}
    </section>)}
    {query.data?.length === 0 && <p>Пока нет доступных торговцев. Продолжите знакомство с Межой.</p>}
  </LocationWindow>
}
